import { render, staticRenderFns } from "./select_hotels.vue?vue&type=template&id=56901fd6&scoped=true"
import script from "./select_hotels.vue?vue&type=script&lang=js"
export * from "./select_hotels.vue?vue&type=script&lang=js"
import style0 from "./select_hotels.vue?vue&type=style&index=0&id=56901fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56901fd6",
  null
  
)

export default component.exports